import cx from "classnames";

import { Dots } from "components/icons/generated";
import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";
import { SideNavigationMobileItemType, NavigationMobileConfigType } from "types/Navigation";
import { AccountContext } from "views/AccountWrapper";
import useNavigationMobileConfig from "hooks/useNavigationMobileConfig";

import MenuItemMobile from "./MenuItem";
import styles from "./styles.module.css";

type SideNavigationProps = {
  showMobileMenu: boolean;
  setShowMobileMenu: (value: boolean) => void;
};

const getConfigItems = (
  navigationConfig: NavigationMobileConfigType,
  types: SideNavigationMobileItemType[]
) =>
  types
    .map((type) => (navigationConfig[type] ? { ...navigationConfig[type], type } : undefined))
    .filter((item) => !!item);

const SideNavigationMobile = ({ setShowMobileMenu }: SideNavigationProps) => {
  const { viewer } = useTypedContext(AccountContext);

  const visibleItems = getConfigItems(
    useNavigationMobileConfig({ isAdmin: viewer.admin }),
    Object.keys(
      useNavigationMobileConfig({ isAdmin: viewer.admin })
    ) as SideNavigationMobileItemType[]
  );

  return (
    <div className={cx(styles.sideNavigationWrapperMobile)}>
      <Box padding="medium large">
        <Box gap="medium" justify="between" align="center" fullWidth className={styles.menu}>
          {visibleItems.map(({ icon, to, rule, title, beta }) => (
            <MenuItemMobile
              beta={beta}
              key={to}
              short={false}
              icon={icon}
              to={to}
              rule={rule}
              ariaLabel={title}
              className={styles.menuItem}
            >
              {title}
            </MenuItemMobile>
          ))}
          <MenuItemMobile
            id="menu-more"
            short={false}
            icon={Dots}
            ariaLabel="Menu open"
            className={styles.menuItem}
            onClick={() => setShowMobileMenu(true)}
          >
            Menu
          </MenuItemMobile>
        </Box>
      </Box>
    </div>
  );
};

export default SideNavigationMobile;
